const colors = [
  { from: '#DC2626', to: '#991B1B' },
  { from: '#2563EB', to: '#1E40AF' },
  { from: '#059669', to: '#047857' },
  { from: '#F59E0B', to: '#D97706' },
  { from: '#7C3AED', to: '#6D28D9' },
  { from: '#EC4899', to: '#DB2777' },
  { from: '#14B8A6', to: '#0D9488' },
  { from: '#F97316', to: '#EA580C' },
  { from: '#8B5CF6', to: '#7C3AED' },
  { from: '#06B6D4', to: '#0891B2' },
];

export const getProjectColor = (projectId: string): { from: string; to: string } => {
  const hash = projectId.split('').reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);

  const index = Math.abs(hash) % colors.length;
  return colors[index];
};
